module.exports = __webpack_public_path__ + "img/universe-phone.48f7df86.png";